import React from 'react';
import { mockData } from '../mock';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const About = () => {
  return (
    <div className="min-h-screen bg-white">
      <SEO 
        title="About Us - T&M Construction Ipswich"
        description="Learn about T&M Construction, trusted builders in Ipswich, Suffolk. Over 10 years experience in renovations, extensions & property refurbishment. Fully insured, 5-star rated."
        keywords="about T&M Construction, builders Ipswich, construction company Suffolk, trusted builders, experienced contractors, family run builders, local builders near me, reliable construction company"
        canonical="/about"
      />
      {/* Hero Section */}
      <section className="pt-56 pb-16 bg-gradient-to-br from-gray-50 to-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">About TM Construction</h1>
            <p className="text-xl text-gray-600 leading-relaxed">
              With over a decade of experience in the construction industry, TM Construction has established itself as a trusted partner for property owners across Suffolk, Essex, and London.
            </p>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Story</h2>
              <div className="space-y-4 text-gray-600 leading-relaxed">
                <p>
                  TM Construction was founded with a simple mission: to deliver exceptional construction and renovation services that exceed our clients' expectations. What started as a small team has grown into one of the region's most trusted construction companies.
                </p>
                <p>
                  Based in Ipswich, we've completed hundreds of projects across Suffolk, Essex, and London, building a reputation for quality workmanship, reliability, and customer satisfaction.
                </p>
              </div>
            </div>
            <div className="relative">
              <img 
                src="https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&h=600&fit=crop" 
                alt="Construction team"
                className="rounded-2xl shadow-2xl"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Values Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Our Values</h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            <Card className="border-2 hover:border-orange-600 transition-all duration-300">
              <CardHeader>
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <LucideIcons.Award className="w-8 h-8 text-orange-600" />
                </div>
                <CardTitle>Quality Craftsmanship</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">We take pride in every project, ensuring the highest standards of workmanship.</p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-600 transition-all duration-300">
              <CardHeader>
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <LucideIcons.Handshake className="w-8 h-8 text-orange-600" />
                </div>
                <CardTitle>Customer First</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">Your satisfaction is our priority. We deliver results that exceed expectations.</p>
              </CardContent>
            </Card>

            <Card className="border-2 hover:border-orange-600 transition-all duration-300">
              <CardHeader>
                <div className="w-14 h-14 bg-orange-100 rounded-lg flex items-center justify-center mb-4">
                  <LucideIcons.Shield className="w-8 h-8 text-orange-600" />
                </div>
                <CardTitle>Reliability</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="text-gray-600">We show up on time, stay on budget, and complete projects as promised.</p>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-orange-600 to-orange-700 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6">Ready to Start Your Project?</h2>
          <Link to="/contact">
            <Button size="lg" className="bg-white text-orange-600 hover:bg-gray-100 px-8">
              Get In Touch
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default About;